import {Box, Button, Stack, Typography, useMediaQuery} from '@mui/material';
import summaryVideo from '$assets/images/thankyou-booking.jpg';
import EyeOpLogo from '$assets/svgs/eye-op.svg?react';
import HospitalMobileLogo from '$assets/svgs/site-logo.svg?react';
import HospitalTextLogo from '$assets/svgs/site-text-logo.svg?react';
import theme from '$modules/booking/theme';
import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {RoutePath} from '$constants/routes';
import {Color} from '$constants/style';
import {styles} from './styles';
import useHospitalInfo from '~/hooks/useHospitalInfo';
import {AppointmentDetailNavigatePayload} from '$modules/booking/types';

const TEXTS = {
  DELETED_APPOINTMENT: 'You deleted your appointment !',
  REFUND_CONTACT:
    'A member of our team will contact you by phone to confirm your preferred refund method.',
  RESCHEDULE_INFO:
    'If you need to reschedule or book a new appointment, you can do so at any time.',
  DISCOVER_HOSPITAL: 'Discover more about Stoneygate',
  BOOK_NEW_APPOINTMENT: 'Book a new appointment',
  VIDEO_ALT: 'video',
};

function AppointmentDeleteSuccess() {
  const navigate = useNavigate();

  const location = useLocation();
  const {hospitalInfo} = useHospitalInfo();

  useEffect(() => {
    const appointment = location.state as AppointmentDetailNavigatePayload;
    if (!appointment) {
      navigate(RoutePath.bookingRoute);
    }
  }, [location.state, navigate]);

  const navigateToHospital = () => {
    if (hospitalInfo?.hospitalURL) {
      window.location.replace(hospitalInfo.hospitalURL);
    }
  };

  const isLarge = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box sx={styles.screenSection}>
      <Box sx={styles.bookingWrapper}>
        <Box sx={styles.appSummaryWrap}>
          <Box sx={styles.header}>
            <Box sx={styles.headerLogoContainer}>
              <EyeOpLogo className="site-logo" />
              {isLarge && <Box sx={styles.divider} />}
              {isLarge && <HospitalTextLogo className="site-logo" />}
            </Box>
            <Box sx={styles.hospitalLogoWrap}>
              <HospitalMobileLogo className="site-logo" />
            </Box>
          </Box>
          <Box sx={styles.appSummarySection}>
            <Stack sx={styles.summaryStack}>
              <Typography variant="h1" sx={styles.summaryHead}>
                {TEXTS.DELETED_APPOINTMENT}
              </Typography>
              <Typography variant="caption" sx={styles.summaryBody}>
                {TEXTS.REFUND_CONTACT}
              </Typography>
              <Typography variant="caption" sx={styles.summaryBody}>
                {TEXTS.RESCHEDULE_INFO}
              </Typography>
            </Stack>
            {hospitalInfo?.hospitalURL && (
              <Stack sx={styles.summaryActionBtnWrap}>
                <Button
                  variant="contained"
                  color="warning"
                  sx={styles.bookingActionBtn}
                  onClick={navigateToHospital}
                >
                  <Typography variant="body1" color={Color.White}>
                    {TEXTS.DISCOVER_HOSPITAL}
                  </Typography>
                </Button>
              </Stack>
            )}
            <Stack sx={styles.summaryActionBtnWrap}>
              <Button
                variant="contained"
                color="primary"
                sx={styles.continueBtn}
                onClick={() => navigate(RoutePath.bookingRoute)}
              >
                {TEXTS.BOOK_NEW_APPOINTMENT}
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>
      <Box sx={styles.appSummaryVideoSection}>
        <img src={summaryVideo} alt={TEXTS.VIDEO_ALT} />
      </Box>
    </Box>
  );
}

export default AppointmentDeleteSuccess;
